/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  RelayNetworkLayer,
  urlMiddleware,
  authMiddleware,
  errorMiddleware,
  retryMiddleware,
  progressMiddleware,
  uploadMiddleware,
} from 'react-relay-network-modern/lib'; // Changed to /lib to avoid mjs issue that fails the build
import {Observable} from 'relay-runtime';
import {IS_DEV_ENV, ConfigService} from '@stackworx/react';
import {SubscriptionClient} from 'subscriptions-transport-ws';

const SHOW_PROGRESS = false;

interface Props {
  token: string;
  logout: () => void;
}

export default ({token, logout}: Props) => {
  const subscriptionClient = new SubscriptionClient(
    // TODO: remove hack
    `${ConfigService.serverUri}/graphql`.replace('http', 'ws'),
    {
      connectionParams: {
        token,
      },
      reconnect: true,
    }
  );

  // @ts-expect-error bad types
  const subscribeFn: SubscribeFunction = (request, variables) => {
    const subscribeObservable = subscriptionClient.request({
      query: request.text ?? '',
      operationName: request.name,
      variables,
    });

    // @ts-expect-error bad types
    return Observable.from(subscribeObservable);
  };

  const network = new RelayNetworkLayer(
    [
      /*
      cacheMiddleware({
        size: 100, // max 100 requests
        ttl: 900000, // 15 minutes
      }),
      */
      urlMiddleware({
        url: () => Promise.resolve(`${ConfigService.serverUri}/graphql`),
      }),
      uploadMiddleware(),
      // IS_DEV_ENV ? loggerMiddleware() : null,
      IS_DEV_ENV ? errorMiddleware() : null,
      // IS_DEV_ENV ? perfMiddleware() : null,
      retryMiddleware({
        fetchTimeout: 15000,
        forceRetry: (cb, delay) => {
          // @ts-expect-error upgrade
          window.forceRelayRetry = cb;
          // eslint-disable-next-line no-console
          console.log(
            `call \`forceRelayRetry()\` for immediately retry! Or wait ${delay} ms.`
          );
        },
        statusCodes: [500, 503, 504],
      }),
      authMiddleware({
        token,
      }),
      SHOW_PROGRESS
        ? progressMiddleware({
            onProgress: (current, total) => {
              // eslint-disable-next-line no-console
              console.log(
                `Downloaded: ${current} B, total: ${
                  total ? total.toString() : '0'
                } B`
              );
            },
          })
        : null,

      (next) => async (req) => {
        req.fetchOpts.headers.Accept = 'application/json';
        // req.fetchOpts.headers['Content-Type'] = 'application/json';

        // TODO x-Request-ID
        // req.fetchOpts.headers['X-Request-ID'] = uuid.v4(); // add `X-Request-ID` to request headers
        req.fetchOpts.credentials = 'same-origin'; // allow to send cookies (sending credentials to same domains)

        try {
          return await next(req);
        } catch (ex) {
          // Logout user out if we get a 401
          if (ex.res && ex.res.status === 401) {
            logout();
          }

          throw ex;
        }
      },
    ],
    {
      subscribeFn,
      noThrow: true,
    }
  );

  return network;
};
